export default "__VITE_ASSET__CP72ndyo__"